// extracted by mini-css-extract-plugin
export default {"closeBtn":"ContentModal_closeBtn__WJU++","titleModal":"ContentModal_titleModal__9zkQN"};